window.MENU = {
    layers: {
        item: $('#menu ul li'),
        active_item_selector: '#menu ul li.active',
        screens: $('#screens'),
        items: {
            settings: $('#menu ul li[data-key=settings]'),
            billing: $('#menu ul li[data-key=billing]')
        }
    },

    init: async () => {
        window.MENU.layers.item.click(function () {
            if(!$(this).hasClass('disabled')) {

                var active_item = $(window.MENU.layers.active_item_selector);
                var active = active_item.attr('data-key');
                var current_active = $(this).attr('data-key');


                if (current_active != active) {
                    window.MENU.layers.screens.removeClass(active);
                    window.MENU.layers.screens.addClass(current_active);

                    window.MENU.layers.item.each(function () {
                        $(this).removeClass('active');
                    });

                    $(this).addClass('active');
                }
            }
        });
    }
};
window.MENU.init();


/* iphone bottom */
var menu_bottom = getComputedStyle(document.documentElement).getPropertyValue("--sab");
menu_bottom = parseInt(menu_bottom.replace('px', ''));
if(menu_bottom > 0) {
    $('#menu').css('padding-bottom', menu_bottom +'px');
    $('#screens').css('height', 'calc(100% - '+ menu_bottom +'px)');
}
/* end iphone bottom */